import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import "../css/leadform.css";

export default function LeadFormModal({
  loanPurpKeyword,
  noteRate,
  formHeading,
  showLeadFormModal,
  onHide,
}) {
  // stores the input field reference in a way that allows us to conditionally render
  // content or scroll to the element on button click.
  const [node, setNode] = useState(null);

  // watches for changes in the form.
  const formRef = useCallback((node) => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showLeadFormModal}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>{formHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BorrowerLeadGenerationTool
          leadSource="INHNPORT-032"
          branch="058"
          loanPurposeKeyword={loanPurpKeyword}
          noteRate={noteRate}
          showModalBackBtn={true}
          statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          ref={formRef}
          offerLoanTypeKeyword="FHA"
          offerLoanProductCode="AA11S00O00"
        />
      </Modal.Body>
    </Modal>
  );
}
